export default __webpack_public_path__ + "static/media/200701 Bonnie -- Watercolor.6e325832.png";